(function (){
    const bannerClose = document.querySelector(".close-banner");
    const alertBanner = document.querySelector(".metz-alert-banner");
    const metzMegamenu = document.querySelectorAll(".metz-megamenu");
    const alertBannerButton = document.querySelector("#alertBannerButton");
    const metzAlertModalClose = document.querySelector(".metz-modal.modal-alert .btn-close");
    if(window.innerWidth < 992 && alertBannerButton){
        if(!getCookie('alertBanner')){
            alertBannerButton.click();
        }

        console.log(getCookie('alertBanner'));

        if(metzAlertModalClose){
            metzAlertModalClose.addEventListener('click',()=>{
                setCookie('alertBanner','alertBannerCookie',1);
            });
        }
    }

    if(bannerClose){
        bannerClose.addEventListener('click',()=>{
            setCookie('alertBanner','alertBannerCookie',1);
            alertBanner.style.display = 'none';
            metzMegamenu.forEach((megaMenu)=>{
                if(megaMenu.classList.contains('has-alert-banner')){
                    megaMenu.classList.remove('has-alert-banner');
                }
            })
        })

    }
})();

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}